import React, { useState } from 'react'
import { Link } from 'gatsby'
import { FiMenu } from 'react-icons/fi'
import { AiOutlineSearch } from 'react-icons/ai'
import { IoMdClose } from 'react-icons/io'
import Container from './styles'
import logo from '../../icons/logo.svg'
import logoMobile from '../../icons/logo-mobile.svg'
import MenuPrimario from '../Menus/MenuPrimario'
import MenuSecundario from '../Menus/MenuSecundario'
import MenuMobile from '../Menus/MenuMobile'
import SearchMobile from '../SearchMobile'
import RedesSociais from '../RedesSociais'

export default function Header({ search }) {
  const [isOpen, setIsOpen] = useState(false)
  const [searchOpen, setSearchOpen] = useState(false)

  return (
    <>
      <Container>
        <div className="MobileTrigger">
          {isOpen ? (
            <IoMdClose size="3em" onClick={() => setIsOpen(false)} />
          ) : (
            <FiMenu size="3em" onClick={() => setIsOpen(true)} />
          )}
        </div>
        <Link to="/" className="logo">
          <figure>
            <img
              src={logoMobile}
              alt="Hospital e Maternidade Santa Joana"
              className="mobile"
            />
            <img
              src={logo}
              alt="Hospital e Maternidade Santa Joana"
              className="desktop"
            />
          </figure>
        </Link>
        {search ? (
          ''
        ) : (
          <div className="SearchTrigger">
            {searchOpen ? (
              <IoMdClose size="3em" onClick={() => setSearchOpen(false)} />
            ) : (
              <AiOutlineSearch size="3em" onClick={() => setSearchOpen(true)} />
            )}
          </div>
        )}
        <div className="navigation">
          <MenuPrimario />
          <RedesSociais />
          <div className="search">
            <Link to="/busca">
              <AiOutlineSearch size="2.2em" />
            </Link>
          </div>
          <MenuSecundario />
        </div>
      </Container>
      {isOpen && <MenuMobile />}
      {searchOpen && <SearchMobile />}
    </>
  )
}
